/**
 * Action Button Item
 * Renders a primary/secondary button with optional "Why?" tooltip
 */

import { Button, Tooltip, makeStyles, tokens } from '@fluentui/react-components'
import { InfoRegular } from '@fluentui/react-icons'
import type { InsightContentItem } from '../../../../domain'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
  },
  tooltipTrigger: {
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'help',
    color: tokens.colorNeutralForeground3,
    ':hover': {
      color: tokens.colorBrandForeground1,
    },
  },
})

export interface ActionButtonItemProps {
  item: InsightContentItem
}

export function ActionButtonItem({ item }: ActionButtonItemProps) {
  const styles = useStyles()
  const appearance = item.buttonVariant === 'secondary' ? 'secondary' : 'primary'

  return (
    <div className={styles.root}>
      <Button appearance={appearance}>{item.content}</Button>
      {item.tooltipContent && (
        <Tooltip content={item.tooltipContent} relationship="description">
          <span className={styles.tooltipTrigger}>
            <InfoRegular />
          </span>
        </Tooltip>
      )}
    </div>
  )
}
